<template>
	<div class="signup-bar" v-if="provider">
		<div class="signup-feature">
			<span class="icon"><svg><use xlink:href="#cog"></use></svg></span>
			<dl v-if="provider.slug === 'waterfall-access-networks'">
				<dt>R{{ provider.meta.installation_fee_override.toLocaleString('en-ZA') }} Installation<sup>1</sup></dt>
				<dd>Payable to Waterfall Access Networks</dd>
			</dl>
			<dl v-else-if="installationFee > 0 && provider.meta.installation_fee_override > 0">
				<dt>R{{ provider.meta.installation_fee_override.toLocaleString('en-ZA') }} Installation<sup>1</sup></dt>
				<dd v-if="provider.meta.installation_fee_override !== provider.meta.installation_fee" class="strike">R{{provider.meta.installation_fee.toLocaleString('en-ZA')}}</dd>
			</dl>
			<dl v-else-if="installationFee > 0 && provider.meta.installation_fee_override == 0">
				<dt>Installation Incl.<sup>1</sup></dt>
				<dd v-if="provider.meta.installation_fee_override !== provider.meta.installation_fee" class="strike">R{{provider.meta.installation_fee.toLocaleString('en-ZA')}}</dd>
			</dl>
			<dl v-else>
				<dt>Installation<sup>1</sup></dt>
				<dd>Included</dd>
			</dl>
		</div><!-- end.signup-feature -->
		<div class="signup-feature">
			<span class="icon"><svg><use xlink:href="#ethernet"></use></svg></span>
			<dl v-if="activationFee > 0 && provider.meta.activation_fee_override > 0">
				<dt>R{{ provider.meta.activation_fee_override.toLocaleString('en-ZA') }} Activation<sup>2</sup></dt>
				<dd v-if="provider.slug === 'purple-forest'">Area dependent</dd>
				<dd v-else-if="provider.meta.activation_fee_override !== provider.meta.activation_fee" class="strike">R{{ activationFee.toLocaleString('en-ZA') }}</dd>
			</dl>
			<dl v-else-if="activationFee > 0 && provider.meta.activation_fee_override == 0">
				<dt>Activation Incl.<sup>2</sup></dt>
				<dd v-if="provider.meta.activation_fee_override !== provider.meta.activation_fee" class="strike">R{{ activationFee.toLocaleString('en-ZA') }}</dd>
			</dl>
			<dl v-else>
				<dt>Activation<sup>2</sup></dt>
				<dd>Included</dd>
			</dl>
		</div><!-- end.signup-feature -->
		<div class="signup-feature">
			<span class="icon"><svg><use xlink:href="#wifi"></use></svg></span>
			<dl v-if="this.provider.slug === 'vuma-reach' || this.provider.slug === 'openserve-web-connect' || this.provider.slug === 'frogfoot-air'">
				<dt>WiFi Router<sup>3</sup></dt>
				<dd>Included with device installed at your home.</dd>
			</dl>
			<dl v-else>
				<dt>WiFi Router Incl.<sup>3</sup></dt>
				<dd class="strike">R999.00</dd>
			</dl>
		</div><!-- end.signup-feature -->
		<a href="#" class="btn gradient-red large" v-scroll-to="'header'"><span>Check Coverage</span></a>
	</div><!-- end.signup-bar -->
</template>
<script>
	export default {
		props: ['provider'],
		computed: {
			installationFee() {
				return this.provider.meta.installation_fee ? this.provider.meta.installation_fee : 0;
			},
			activationFee() {
				return this.provider.meta.activation_fee ? this.provider.meta.activation_fee : 0;
			},
		},
		methods: {
			checkCoverage(e) {
				if (dataLayer && e) {
					console.log("pushing GTM event")
					dataLayer.push({
						event: 'Browse_Packages.Check_Coverage.Click'
					});
				}
			}
		}
	}
</script>
